<!-- 公司图片 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">图片样式</div>
                        <FormItem label="图片样式">
                            <RadioGroup
                                v-model="newFormData.content.autoplay"
                                @on-change="changeRadio"
                            >
                                <Radio label="1">轮播</Radio>
                                <Radio label="0">平铺</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.autoplay == 1">
                            <div class="form-title">轮播指示器</div>
                            <FormItem label="指示器"
                                ><ColorPicker
                                    v-model="
                                        newFormData.content.indicator_color
                                    "
                            /></FormItem>
                        </template>
                        <template v-if="newFormData.content.autoplay == 0">
                            <div class="form-title">平铺样式</div>
                            <div class="img-divs">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in flatStyleList"
                                    :key="index"
                                    :class="
                                        newFormData.content.style_id == index
                                            ? 'style-active'
                                            : 'style-default'
                                    "
                                    @click="changeImgStyle(index, item)"
                                >
                                    <img
                                        class="w80"
                                        :src="
                                            newFormData.content.style_id ==
                                            index
                                                ? item.img_active
                                                : item.img
                                        "
                                    />
                                    <span>{{ item.text }}</span>
                                </div>
                            </div>
                        </template>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            name_id: "1",
            flatStyleList: [
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/1-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/1-2.png",
                    text: "1张图",
                    num: 1,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/2-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/2-2.png",
                    text: "2张图",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/3-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/3-2.png",
                    text: "3张图",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/4-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/4-2.png",
                    text: "4张图",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/5-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/5-2.png",
                    text: "2张图平分",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/6-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/6-2.png",
                    text: "3张图平分",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/7-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/7-2.png",
                    text: "4张左右平分",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/8-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/8-2.png",
                    text: "4张上下平分",
                    num: 4,
                },
            ],
        };
    },
    mounted() {},
    methods: {
        selectName(name) {
            this.name_id = name;
        },
        changeImgStyle(index, item) {
            this.newFormData.content.style_id = index;
            const newList = this.newFormData.content.imgList.filter(
                (img) => img.picview.trim() !== ""
            );
            const emptyCount = Math.max(0, item.num - newList.length);
            const emptyItems = Array(emptyCount)
                .fill()
                .map(() => ({ value: "", picview: "" }));
            this.newFormData.content.imgList = [...newList, ...emptyItems];
        },
        changeRadio(event) {
            if (event == 0) {
                this.newFormData.content.style_id = 0;
            }
        },
    },
};
</script>
<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: var(--primary-color);
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.style-active {
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
}
.style-default {
    border: 1px solid #dadada;
    color: #333333;
}
.img-divs {
    padding: 12px 0 0 12px;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.img-div {
    margin: 0 12px 12px 0;
    width: 100px;
    height: 100px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.w80 {
    width: 80px;
}
::v-deep .ivu-slider-bar {
    background-color: var(--primary-color);
}
::v-deep .ivu-slider-button {
    border: 2px solid var(--primary-color);
}
</style>